import React from 'react';
import '../../../styles/containers/Prayer/components/next-button.scss';
function NextButton({handleClick}) {
    return (
        <button className='next-button-container2' onClick={handleClick} style={{
            backgroud:'#D34714'
        }}>
            Next
        </button>
    )
}

export default NextButton
